import { gql } from '@apollo/client';

export const GET_ADVERTISERS_BY_ORG_ID = gql`
  query getAdvertisersByOrgId($orgId: ID!, $accessTypes: [String!]) {
    getAdvertisersByOrgId(orgId: $orgId, accessTypes: $accessTypes) {
      organizationId
      advertisers {
        advertiserId
        advertiserName
        adAccounts {
          id
          name
        }
      }
    }
  }
`;
